import script from "./Counter.vue?vue&type=script&setup=true&lang=js"
export * from "./Counter.vue?vue&type=script&setup=true&lang=js"

import "./Counter.vue?vue&type=style&index=0&id=6bb77aa0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bb77aa0"]])

export default __exports__